<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="standings.length == 0">
        <p>No standings data found.</p>
        <!--      footer text-->
        <div class="note-text text-center py-10">
            <p>
                (Legends League Cricket 2022/23 Standings) Are Brought to You by Planet Cricket, Keep Up to Date with Your Favorite Team's Positions and Standings in the League. Follow the (Legends League Cricket 2022/23 Standings) with Our Exclusive Analysis and Points Tracker.
            </p>
        </div>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="table-responsive" v-for="(group_standing,key) in group_standings">
            <div class="match-table text-white custom-tb">
                <div class="thead">
                    <div class="table-row">
                        <div class="th"># team {{ Object.keys(group_standings).length > 1 ? '('+key+')' : '' }}</div>
                        <div class="th">M</div>
                        <div class="th">W</div>
                        <div class="th">D</div>
                        <div class="th">N/R</div>
                        <div class="th">L</div>
                        <div class="th">NRR</div>
                        <div class="th">pts</div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" v-for="standing in group_standing.items" :key="standing.id">
                            <div class="td">
                                <span class="title">{{ standing.position }}.
                                    <router-link :to="{ name: 'TeamDetails.Players', params:  {  team: standing.team.slug} }">
                                        <u> {{ standing.team_name }} </u>
                                    </router-link>
                                </span>

                            </div>
                            <div class="td">{{ standing.matches || 0 }}</div>
                            <div class="td">{{ standing.won || 0 }}</div>
                            <div class="td">{{ standing.tied || 0 }}</div>
                            <div class="td">{{ standing.no_results || 0 }}</div>
                            <div class="td">{{ standing.lost || 0 }}</div>
                            <div class="td">{{ standing.net_RR || '-' }}</div>
                            <div class="td">{{ standing.points || 0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Footer TEXT -->
        <div class="note-text text-center py-10">
            <p>
                (Legends League Cricket 2022/23 Standings) Are Brought to You by Planet Cricket, Keep Up to Date with Your Favorite Team's Positions and Standings in the League. Follow the (Legends League Cricket 2022/23 Standings) with Our Exclusive Analysis and Points Tracker.
            </p>
        </div>
    </div>
</template>

<script>
    import collect from 'collect.js';
    export default {
        name: 'tournamentStandings',

        data() {
            return {
                standings: []
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                let teams = []
                this.standings.forEach((standing) => {
                teams.push(
                        {
                            "@type": "SportsTeam",
                            "name": standing.team.name,
                            logo: standing.team.flag,
                            "location": {
                            "@type": "Place",
                            "name": standing.team.name + ", " + standing.team.country,
                            "address": {
                            "@type": "PostalAddress",
                            "name": standing.team.name + ", " + standing.team.country,
                            }
                }
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": teams
            }
        },

        metaInfo() {
            if (!Components['tournamentDetail'])
                return
            let title = `${Components['tournamentDetail'].tournament.name} Live Score, Schedule, Matches, Point Table, Fixture - Planet Cricket`;
            let description = `Get all the live cricket scores, fixtures, latest results, match statistics, Point tables, Fixtures for all ${Components['tournamentDetail'].tournament.name} matches at Planet Cricket`;
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main()
            }
        },
        mounted() {
            this.main()
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$TOURNAMENT_STANDINGS_API.replace(':tournament', this.$route.params.tournament))
                        .then(response => {
                            this.is_data_ready = true
                            this.standings = response.data.result.standings || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
        },
        computed: {
            group_standings() {
                return collect(this.standings).groupBy('group').sortKeys().all();
            }
        }
    }
</script>


